var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9BBF0AA0-3660-4EC4-BA07-5B6ACBC79FB8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Dropdown",
    transform: "translate(-43.000000, -108.000000)",
    fill: "#195477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(20.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.31323096 L0,11.4122126 C0,12.6659804 1.02281059,13.688791 2.27657841,13.688791 L9.6305499,13.688791 C10.8843177,13.688791 11.9071283,12.6659804 11.9071283,11.4122126 L11.9071283,9.93848554 C11.9071283,9.68919837 11.705499,9.48756904 11.4562118,9.48756904 C11.2069246,9.48756904 11.0052953,9.68919837 11.0052953,9.93848554 L11.0052953,11.4122126 C11.0052953,12.1710721 10.3857434,12.790624 9.62688391,12.790624 L2.27657841,12.790624 C1.51771894,12.790624 0.898167006,12.1710721 0.898167006,11.4122126 L0.898167006,2.31323096 C0.898167006,1.55437149 1.51771894,0.934819552 2.27657841,0.934819552 L9.6305499,0.934819552 C10.3894094,0.934819552 11.0089613,1.55437149 11.0089613,2.31323096 L11.0089613,3.78695804 C11.0089613,4.03624521 11.2105906,4.23787454 11.4598778,4.23787454 C11.709165,4.23787454 11.9107943,4.03624521 11.9107943,3.78695804 L11.9107943,2.31323096 C11.9107943,1.05946314 10.8879837,0.0366525458 9.63421589,0.0366525458 L2.27657841,0.0366525458 C1.02281059,0.0366525458 0,1.05579715 0,2.31323096",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1287316,10.2537825 C14.2166786,10.3417295 14.3303609,10.385758 14.4476358,10.385758 C14.5649475,10.385758 14.6786297,10.3417295 14.7665768,10.2537825 L17.8423772,7.17801874 C18.0183446,7.00205132 18.0183446,6.71977026 17.8423772,6.54380285 L14.7665768,3.46800244 C14.590646,3.29207169 14.3083283,3.29207169 14.1323976,3.46800244 C13.9564301,3.64400652 13.9564301,3.92625092 14.1323976,4.10225499 L16.4419699,6.41182729 L8.01386395,6.41182729 C7.76454012,6.41182729 7.56291079,6.61345662 7.56291079,6.86274379 C7.56291079,7.11203096 7.76454012,7.31366029 8.01386395,7.31366029 L16.4383039,7.31366029 L14.1287316,9.62323259 C13.9527275,9.79553401 13.9527275,10.0814811 14.1287316,10.2537825",
    id: "Fill-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6f05349f.svg";
export { ForwardRef as ReactComponent };